import { render, staticRenderFns } from "./itemDescription.vue?vue&type=template&id=aea35d64&scoped=true&lang=html&"
import script from "./itemDescription.vue?vue&type=script&lang=js&"
export * from "./itemDescription.vue?vue&type=script&lang=js&"
import style0 from "./itemDescription.vue?vue&type=style&index=0&id=aea35d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea35d64",
  null
  
)

export default component.exports